module.exports = __webpack_public_path__ + "static/media/36_tn.502e42ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/36_tn.jpg
// module id = 672
// module chunks = 0